<div class="container-saldo">
    <h2 style="text-align: center;">Saldo</h2>
    <p-table [value]="estadoCuenta" [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template pTemplate="header">
            <tr>
                <th>Fecha</th>
                <th>Folio</th>
                <th>Concepto</th>
                <th>Puntos(-)</th>
                <th>Puntos(+)</th>
                <th>Saldo</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-estadocuenta>
            <tr>
                <td>{{estadocuenta.fecha | date:'dd/MM/yyyy'}}</td>
                <td>{{estadocuenta.folio}}</td>
                <td>{{estadocuenta.concepto}}</td>
                <td>{{estadocuenta.canje}}</td>
                <td>{{estadocuenta.puntos}}</td>
                <td>{{estadocuenta.saldo}}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
            <tr>
                <td colspan="6">
                    Sin registros
                </td>
            </tr>
        </ng-template>
    </p-table>

</div>